import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/green_bell.svg'
import _imports_1 from '@/assets/icons/warn.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-32f0dd56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "providers-list" }
const _hoisted_2 = { class: "listing-titles" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "payment-provider-feature-flag-message"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "payment-provider-feature-flag-message"
}
const _hoisted_7 = { class: "savings-container" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Info"
}, null, -1))
const _hoisted_12 = { class: "text-black" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Warning"
}, null, -1))
const _hoisted_14 = { class: "text-black" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    height: "67",
    alt: "Info"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    height: "67",
    alt: "Info"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    height: "67",
    alt: "Info"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_BottomBar = _resolveComponent("BottomBar")!
  const _component_HighlightPopup = _resolveComponent("HighlightPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("PaymentsProvidersView-HowToPay")), 1),
      (_ctx.filteredProviders[0].length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[0], (provider) => {
              return (_openBlock(), _createElementBlock("li", {
                key: provider.name
              }, [
                _createVNode(_component_CardItem, {
                  "logo-src": provider.logo,
                  "logo-alt": provider.displayName,
                  title: _ctx.t(provider.displayName),
                  subtitle: provider.tooltipPrefix ? _ctx.t(provider.tooltipPrefix) : '',
                  "right-text": _ctx.computeRightText(provider),
                  inactive: 
              provider.featureFlagStatus?.disabled === true ||
              (_ctx.country === 'PE' && _ctx.isOtherAmountSelected && !_ctx.otherAmountAllowedProviders.includes(provider.name))
            ,
                  onClick: ($event: any) => (_ctx.handleSelectPaymentProvider(provider))
                }, null, 8, ["logo-src", "logo-alt", "title", "subtitle", "right-text", "inactive", "onClick"]),
                (provider.featureFlagStatus?.disabled === true)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(provider.featureFlagStatus?.title), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.filteredProviders[1].length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProviders[1], (provider) => {
              return (_openBlock(), _createElementBlock("li", {
                key: provider.name
              }, [
                _createVNode(_component_CardItem, {
                  "logo-src": provider.logo,
                  "logo-alt": provider.displayName,
                  title: _ctx.t(provider.displayName),
                  subtitle: provider.tooltipPrefix ? _ctx.t(provider.tooltipPrefix) : '',
                  "right-text": _ctx.computeRightText(provider),
                  inactive: 
              provider.featureFlagStatus?.disabled === true ||
              (_ctx.country === 'PE' && _ctx.isOtherAmountSelected && !_ctx.otherAmountAllowedProviders.includes(provider.name))
            ,
                  onClick: ($event: any) => (_ctx.handleSelectPaymentProvider(provider))
                }, null, 8, ["logo-src", "logo-alt", "title", "subtitle", "right-text", "inactive", "onClick"]),
                (provider.featureFlagStatus?.disabled === true)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(provider.featureFlagStatus?.title), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_BottomBar, {
      text: _ctx.t('PaymentsProvidersView-PaymentAmount'),
      amount: _ctx.amount,
      "term-label": _ctx.term,
      onChangePaymentAmount: _ctx.handleAmountChange
    }, null, 8, ["text", "amount", "term-label", "onChangePaymentAmount"]),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.onHighlighted,
      onClosePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClosePopup('highLight'))),
      onDismissPopup: _ctx.onDismissPopup
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_ctx.t("Popup-Pay-Without-Commissions")), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.t("Popup-Save-Money-Using-These-Options")), 1),
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlightedProviders, (provider) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _ctx.t(provider.name),
              class: "savings"
            }, [
              _createElementVNode("img", {
                src: provider.logo,
                alt: provider.displayName
              }, null, 8, _hoisted_8)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "onDismissPopup"]),
    (_ctx.pixProvider)
      ? (_openBlock(), _createBlock(_component_HighlightPopup, {
          key: 0,
          "is-visible": _ctx.showPixIsFasterPopup,
          onClosePopup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClosePopup('pixPopup'))),
          onDismissPopup: _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.pixProvider.logo,
              alt: _ctx.pixProvider.displayName
            }, null, 8, _hoisted_9),
            _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.t("Popup-Pix-Faster")), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.t("Popup-Pix-Compare-To-Boleto")), 1)
          ]),
          _: 1
        }, 8, ["is-visible", "onDismissPopup"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.showPix10MinutePopup,
      "button-text": _ctx.t('continue'),
      onClosePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClosePopup('pix10MinutePopup'))),
      onDismissPopup: _ctx.onDismissPopup
    }, {
      default: _withCtx(() => [
        _hoisted_11,
        _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.t("Popup-Pix-First-Time-Title")), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.t("Popup-Pix-First-Time-Description")), 1)
      ]),
      _: 1
    }, 8, ["is-visible", "button-text", "onDismissPopup"]),
    (_ctx.pixProvider)
      ? (_openBlock(), _createBlock(_component_HighlightPopup, {
          key: 1,
          id: "boletoPopup",
          "is-visible": _ctx.showBoletoPopup,
          "bottom-link-text": _ctx.t('try-with-pix'),
          "button-text": _ctx.boletoPopupButtonText,
          onBottomLinkClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tryPix())),
          onClosePopup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClosePopup('boletoPopup'))),
          onDismissPopup: _ctx.onDismissPopup
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.boletoPopupTitle), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.boletoPopupDescription), 1)
          ]),
          _: 1
        }, 8, ["is-visible", "bottom-link-text", "button-text", "onDismissPopup"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.detailsPopupObject !== undefined,
      "button-text": _ctx.detailsPopupObject?.disabled == true ? _ctx.t('close') : _ctx.t('continue'),
      "bottom-link-text": _ctx.detailsPopupObject?.disabled == true ? undefined : _ctx.t('cancel'),
      onClosePopup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClosePopup('details'))),
      onDismissPopup: _ctx.onDismissPopup,
      onBottomLinkClick: _ctx.onDismissPopup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("h1", null, _toDisplayString(_ctx.detailsPopupObject?.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.detailsPopupObject?.banner), 1)
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "button-text", "bottom-link-text", "onDismissPopup", "onBottomLinkClick"]),
    _createVNode(_component_HighlightPopup, {
      "is-visible": 
      !!_ctx.providers.globalWarning.value?.title && !!_ctx.providers.globalWarning.value?.banner && !_ctx.globalWarningDismissed
    ,
      "button-text": _ctx.t('close'),
      onClosePopup: _ctx.dismissGlobalWarning,
      onDismissPopup: _ctx.dismissGlobalWarning
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_16,
          _createElementVNode("h1", null, _toDisplayString(_ctx.providers.globalWarning.value?.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.providers.globalWarning.value?.banner), 1)
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "button-text", "onClosePopup", "onDismissPopup"]),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.showOtherAmountPopup,
      "button-text": _ctx.t('close'),
      onClosePopup: _ctx.onDismissPopup,
      onDismissPopup: _ctx.onDismissPopup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("h1", null, _toDisplayString(_ctx.t("attention")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t("other-amount-qr-content")), 1)
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "button-text", "onClosePopup", "onDismissPopup"])
  ], 64))
}